import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Our Vision",
    body: "To strengthen government schools by improving the quality of education and enabling students from resource-limited communities to learn, lead, and thrive — ensuring every child can pursue their dreams through meaningful, equitable learning.",
  },
  {
    n: "02",
    title: "Our Mission",
    body: "To transform school education by empowering teachers and students through programs emphasizing teacher support, life skills, socio-emotional learning, leadership, and effective public speaking.",
  },
  {
    n: "03",
    title: "How It Began",
    body: "Education in India doesn't fail for lack of buildings or books, but for lack of teachers. What began as a small volunteer-driven idea now supports government schools across Hyderabad and Ranga Reddy — from MPUP Gowlidoddi to Gandipet, Gandhamguda, and Mazeedpura.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-24 lg:py-32 bg-bonealt/60" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 lg:mb-24"
      >
        <span className="text-xs font-bold tracking-[0.3em] uppercase text-terra" data-testid="manifesto-eyebrow">Our Manifesto</span>
        <h2 className="font-serif font-bold tracking-tighter text-forest text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl" data-testid="manifesto-heading">
          Three beliefs we <span className="italic text-terra">build</span> everything on.
        </h2>
      </motion.div>

      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-4 lg:sticky lg:top-28"
        >
          <div className="relative">
            <div className="absolute -inset-0 translate-x-4 translate-y-4 bg-forest -z-0" />
            <img
              src="/photos/team-students.jpg"
              alt="LLI team with students during a school distribution drive"
              className="relative w-full h-[420px] object-cover img-bw border border-forest/20"
              data-testid="manifesto-image"
            />
          </div>
          <p className="mt-6 text-xs text-moss italic">A distribution drive at one of our partner schools, Hyderabad.</p>
        </motion.div>

        <div className="lg:col-span-8 flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="grid sm:grid-cols-[auto_1fr] gap-6 py-10 border-t border-forest/20 first:border-t-0 first:pt-0 group"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-serif font-black text-7xl lg:text-8xl text-terra leading-none transition-transform duration-300 group-hover:-translate-y-1">
                {c.n}
              </span>
              <div>
                <h3 className="font-serif font-bold text-2xl lg:text-3xl text-forest tracking-tight">{c.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-moss max-w-xl">{c.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  </section>
);
